// extracted by mini-css-extract-plugin
export var acceptButton = "_3a-5";
export var fullContent = "_3a-4";
export var link = "_3a-6";
export var linkIcon = "_3a-7";
export var sideContent = "_3a-3";
export var sideImage = "_3a-2";
export var sideImageWrapper = "_3a-1";
export var splitLayout = "_3a-0";